// extracted by mini-css-extract-plugin
export default {"container":"cover_container__Z7LJ8","abso":"cover_abso__aHWXD","scrollIcon":"cover_scrollIcon__T2k+T","blink":"cover_blink__xkVLB"};